import { Vector3 } from 'three';

/**
 * @description utility functions for vectors, units, and precision
 */
export class VectorUtils {
  /**
   * @description expects a vector in mm unit, and converts it to meter without changing precision
   */
  static mmToMeters(vectorInMm: Vector3): Vector3 {
    return vectorInMm.clone().divideScalar(1000);
  }

  /**
   * @description expects a vector in m. Converts it to mm
   */
  static metersToMm(vectorInMeters: Vector3): Vector3 {
    return vectorInMeters.clone().multiplyScalar(1000);
  }
}
